import { Component, OnInit, Input } from '@angular/core';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR } from '../../../../services/search-service';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';

@Component({
  selector: 'app-motor-autocomplete',
  templateUrl: './motor-autocomplete.component.html',
  styleUrls: ['./motor-autocomplete.component.scss']
})
export class MotorAutocompleteComponent implements OnInit {

  @Input('placeholder') placeholder = 'Filtrar por motor';
  
  // Motores
  public motores = [];
  public motoresStateControl: FormControl;
  public filteredMotores: Observable<any>;
  public selectedMotores = [];

  constructor(private searchService: SearchService) {

    // Motores
    this.motoresStateControl = new FormControl();
    this.filteredMotores = this.motoresStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          if (value && value.length > 2){
            return this.searchService.searchAutocomplete(value, SEARCH_TYPE_MOTOR);
          } else {
            return Observable.from([]);
          }
        })
        .map( value => {
          return value;
        });
  }

  ngOnInit() {
  }
  
  selectedMotor(event: MdOptionSelectionChange, value) {
    if (event.source.selected &&
          this.selectedMotores.filter(v => v.Id === value.Id).length === 0) {
        this.selectedMotores.push(value);
    }
  }

  removeMotor(motor){
    this.selectedMotores.splice(this.selectedMotores.findIndex(v => v.Id === motor.Id), 1);
  }

  displayFn(value){
    return null;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/motor-autocomplete/motor-autocomplete.component.ts